'use strict';

import VendorPlugins from "./VendorPlugins";
import CustomControls from "./CustomControls";
import KoeffsAndValues from "./KoeffsAndValues";
import Helpers from "./Helpers";

class Calculator {
    constructor(initALL = true) {
        console.log('Init Calculator module');
        if (initALL) this.initVars().initOnStart().initSizes().initAutomationSelects().initGrills().initItemsTable().initSubmitForm();
    }

    initVars() {
        this.descriptions = [];

        return this;
    }

    initOnStart() {
        // convectors series tab selection
        $('.convectors-menu a[data-toggle="pill"]').on('shown.bs.tab', () => {
            console.log(this.selection, this.options);
            if (this.selection.series !== "automation") {
                this.onTabSelected().normalizePower().normalizePowerComponent();
                $("#qty-input").show();
            } else {
                $("#qty-input").hide();
            }
        });

        // variants tab selection
        $('.variants-menu a[data-toggle="pill"]').on('shown.bs.tab', () => {
            console.log(this.selection, this.options);
            if (this.selection.series !== "automation")
                this.onTabSelected().normalizePower();
        });

        // reaction on iCheck checkbox toggling
        $(".checkbox input:checkbox").on("ifToggled", () => this.onTabSelected());
        $(".checkbox input:radio").on("ifChecked", () => this.onTabSelected());

        // temperature block initialization
        $("#input_t, #output_t, #room_t").on("change", () => this.normalizePowerComponent().normalizePower());
        $("#ITF_option_W, #ITF_option_H").on("ifChecked", () => this.normalizePowerComponent().normalizePower());
        $("#ITF_options").on("ifToggled", () => this.normalizePowerComponent().normalizePower());
        $("[name=mount_scheme]").on("change", () => this.normalizeItfCommentLabel());
        // Vent option toggle reaction
        $("[name=ventilation]").on("ifToggled", () => this.normalizePowerComponent().normalizePower());
        $("[id$=_vent_option_t_vkhod]").on("change", () => this.normalizePowerComponent().normalizePower());
        $("[id$=_vent_option_raskh_pritoch_vozd]").on("change", () => this.normalizePowerComponent().normalizePower());

        // add to table activity initialization
        $("#add_to_table").on("click", (event) => this.onAddItemToTable(event));
        $("#spares_add_to_table, #controllers_add_to_table, #blowers_add_to_table, #servos_add_to_table, #cassetes_add_to_table, #to_itt_add_to_table, #to_itf_add_to_table")
            .on("click", (event) => this.onAddAutomationItemToTable(event));

        // common discount activity
        $("#apply_common_discount").on("click", () => {
            let common_discount = +$("#common_discount").val();

            $('table.calculation tbody tr').each((index, item) => $(item).find(".discount input").filter(":not(:disabled)").val(common_discount).trigger("change"));
        });

        // disable clicks on disabled custom toggle buttons
        $(".btn-group-toggle").on("click", ".btn.disabled", () => {
            return false;
        });


        // popover on color select circles
        $(".color-control").popover();

        this.refreshSubTotal();

        return this;
        // return this.onTabSelected();
    }

    initItemsTable() {
        // reaction an row-level fields changing
        // remove item from table activity initialization
        $('table.calculation tbody')
            .on("change", ".table-qty-control, .discount", event => {
                let row_discount = 0,
                    $tdList = $(event.target).closest("tr").children(),
                    item_count = +$tdList.eq(2).find(".number").text(),
                    rowItemPrice = +Helpers.cleanSpaces($tdList.eq(3).text().trim());

                $tdList.eq(4).text(Helpers.numberWithCommas(rowItemPrice * item_count));
                $tdList.eq(5).each((ind, it) => {
                    row_discount = +$(it).find("input").val()
                });
                $tdList.eq(6).text(Helpers.numberWithCommas(rowItemPrice * item_count * (1 - row_discount / 100)));

                this.refreshSubTotal();
            })
            .on("click", ".del-item", event => {
                if (confirm("Вы уверены?")) {
                    $(event.currentTarget).closest("tr").remove();
                    this.refreshSubTotal();
                }
                return false;
            });

        return this;
    }

    initSubmitForm() {
        $("#calculations-form").on("submit", (event) => {
            let $form = $(event.target);
            let itemName = $form.data("item-name");

            $("<input type='hidden' name='temperatures' value='" + $("#column-temperature-badge").text() + "'/>").appendTo($form);

            $.each($("table.calculation tbody tr"), (index, tr) => {
                $("<input type='hidden' name='" + itemName + "[" + index + "].articul' value='" + $(tr).children().eq(0).text() + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].power' value='" + $(tr).children().eq(1).text() + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].quantity' value='" + Helpers.cleanSpaces($(tr).children().eq(2).find(".number").text()) + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].price' value='" + Helpers.cleanSpaces($(tr).children().eq(3).text()) + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].cost' value='" + Helpers.cleanSpaces($(tr).children().eq(4).text()) + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].discount' value='" + Helpers.cleanSpaces($(tr).children().eq(5).find("input[type=number]").val()) + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].weight' value='" + $(tr).data("weight") + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].volume' value='" + $(tr).data("volume") + "'/>").appendTo($form);
                $("<input type='hidden' name='" + itemName + "[" + index + "].description' value='" + $(tr).data("description") + "'/>").appendTo($form);
            });
        });

        return this;
    }

    initGrills() {
        $(".grills input[type=radio]")
            .on("change", event => this.normalizeGrillColors(event.target).normalizeFrameColors())
            .filter(":checked").trigger("change");

        return this;
    }

    initSizes() {
        $("select[id*=shirina], select[id*=visota], select[id*=dlina]").not('[id^=CornerSelectBox]').not('[id^=CASSETE]').on("change", (event) => this.normalizePower(event));

        $("#ITTN_visota, #ITTC_visota, #ITTZN_visota, #ITTZC_visota, #ITTBZN_visota, #ITTBZC_visota, #ITTN_shirina, #ITTBN_shirina, #ITTZN_shirina, #ITTZC_shirina, #ITTBZN_shirina, #ITTBZC_shirina")
            .on("change", () => this.normalizeGrills());

        $("#ITTN_visota, #ITTC_visota, #ITTLN_visota, #ITTLC_visota").on("change", () => this.normalizeDrenazhOptions());

        $("#ITTC_shirina, #ITTBC_shirina, #ITTZC_shirina, #ITTBZC_shirina").on("change", () => this.normalizeGrills().normalizeDlinas());

        $("#ITTLC_shirina, #ITTBLC_shirina").on("change", () => this.normalizeDlinas());

        $("#ITF_visota, #ITF_shirina").on("change", () => this.normalizeMountSchemes());

        return this;
    }

    initAutomationSelects() {
        $("#BLOWERS_list").on("change", (event) => this.normalizeAutomationSelects(event)).trigger("change");
        return this;
    }

    onTabSelected() {
        $("#" + this.selection.series + "_variant_toggle .checkbox").show();

        return (this.options.isFloor) ?
            this
                .normalizeHWOptions()
                .normalizeNozhki()
                .normalizeITFSizes()
                .normalizeMountSchemes()
            :
            this
                .normalizeDrenazhOptions()
                .normalizeGOption()
                .normalizeVentOptions()
                .normalizeVentOptionsPloshPatrubka()
                .normalizeVent24Options()
                .normalizeFrameColors()
                .normalizeNoGrillOption()
                .normalizeGrills()
                .normalizeDlinas()
                .normalizeShirinas()
                .normalizeVisotas();
    }

    normalizeDrenazhOptions() {
        let selection = this.selection;

        if (selection.variant === "ITTN" || selection.variant === "ITTC" || selection.variant === "ITTLN" || selection.variant === "ITTLC") {
            // common part of ITT
            if ($("#" + selection.series + "_nerzh").is(":checked") && this.dimensions.visota >= 90)
                $("#" + selection.series + "_drenazh").closest(".checkbox").show();
            else
                $("#" + selection.series + "_drenazh").closest(".checkbox").hide();
        } else {
            $("#" + selection.series + "_drenazh").closest(".checkbox").hide();
        }

        return this;
    }

    normalizeVentOptions() {
        let selection = this.selection,
            $vent = $("#" + selection.series + "_vent"),
            $vent_options = $("#" + selection.series + "_vent_options");
            // $visota = this.$dimensions.$visota;

        switch (selection.series) {
            case "ITT":
            case "ITTL":
            case "ITTZ":
                $vent.closest(".checkbox").show();
                if ($vent.is(":checked")) {
                    // let normalizedVisota;
                    // if ($visota.val() == 190) {
                    //     normalizedVisota = 190;
                    // } else {
                    //     normalizedVisota = 140;
                    // }
                    // $visota.val(normalizedVisota)
                    //     .find("> option")
                    //     .filter("[value!=140][value!=190]")
                    //     .prop("disabled", true).parent()
                    //     .select2(VendorPlugins.select2_noSearch_Options());
                    $vent_options.show()
                } else {
                    // $visota.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_noSearch_Options());
                    $vent_options.hide()
                }
                break;
            default:
                $vent.closest(".checkbox").show();
        }
        return this;
    }

    normalizeVentOptionsPloshPatrubka() {
        $("[name$=_vent_option_raskh_pritoch_vozd]").change((event) => {
            $(`#${event.target.id.replace("_vent_option_raskh_pritoch_vozd", "_vent_option_rec_plosh_patr")}`)
                .val(`> ${Math.round(parseFloat(event.target.value)*10000/6480)}`)
        }).change()

        return this;
    }

    normalizeVent24Options() {
        switch (this.selection.series) {
            case 'ITTB':
                if ($("#ITTB_vent24").is(":checked")) {
                    $(".ITTB_vent24").show();
                    $("#ITTB_no-module").closest('.checkbox').hide();
                } else {
                    $(".ITTB_vent24").hide();
                    $("#ITTB_no-module").closest('.checkbox').show();
                }
                break;
            case 'ITTBL':
                if ($("#ITTBL_vent24").is(":checked")) {
                    $(".ITTBL_vent24").show();
                    $("#ITTBL_no-module").closest('.checkbox').hide();
                } else {
                    $(".ITTBL_vent24").hide();
                    $("#ITTBL_no-module").closest('.checkbox').show();
                }
                break;
            case 'ITTBZ':
                if ($("#ITTBZ_vent24").is(":checked")) {
                    $(".ITTBZ_vent24").show();
                    $("#ITTBZ_no-module").closest('.checkbox').hide();
                } else {
                    $(".ITTBZ_vent24").hide();
                    $("#ITTBZ_no-module").closest('.checkbox').show();
                }
                break;
        }

        return this;
    }

    normalizeGOption() {
        let selection = this.selection,
            $option_g = $("#" + selection.series + "_option_g"),
            $visota = this.$dimensions.$visota,
            $shirina = this.$dimensions.$shirina;

        switch (selection.variant) {
            case "ITTZN":
            case "ITTZC":
            case "ITTBZN":
            case "ITTBZC":
                if ($option_g.is(":checked")) {
                    if (parseInt($visota.val()) < 90) {
                        $visota.val(90);
                    }
                    if (parseInt($shirina.val()) > 350) {
                        $shirina.val(350);
                    }
                    $visota.find("> option").each((index, item) => {
                        if (item.value <= 75) {
                            item.disabled = "disabled";
                        }
                    });
                    $shirina.find("> option").each((index, item) => {
                        if (item.value >= 400) {
                            item.disabled = "disabled";
                        }
                    });
                    $visota.select2(VendorPlugins.select2_noSearch_Options());
                    $shirina.select2(VendorPlugins.select2_noSearch_Options());

                    let $SGZ = $("[name=" + selection.variant + "_grill][value=SGZ]");
                    if ($SGZ.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=LGA]").iCheck("check");
                    }
                    $SGZ.prop("disabled", true);

                    let $SGWZ = $("[name=" + selection.variant + "_grill][value=SGWZ]");
                    if ($SGWZ.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=LGA]").iCheck("check");
                    }
                    $SGWZ.prop("disabled", true);

                    let $PGZ = $("[name=" + selection.variant + "_grill][value=PGZ]");
                    if ($PGZ.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=LGA]").iCheck("check");
                    }
                    $PGZ.prop("disabled", true);

                    $("[name=" + selection.variant + "_grill][value=LGA]").prop("disabled", false);
                } else {
                    $visota.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_noSearch_Options());
                    $shirina.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_noSearch_Options());
                    $("[name=" + selection.variant + "_grill][value=SGZ]").prop("disabled", false);
                    $("[name=" + selection.variant + "_grill][value=SGWZ]").prop("disabled", false);
                    $("[name=" + selection.variant + "_grill][value=PGZ]").prop("disabled", false);

                    let $LGA = $("[name=" + selection.variant + "_grill][value=LGA]");
                    if ($LGA.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=SGZ]").iCheck("check");
                    }
                    $LGA.prop("disabled", true);
                }
                break;
            default:
                $option_g.closest(".checkbox").show();
        }
        return this;
    }

    normalizeFrameColors() {
        let $colors = $("#" + this.selection.variant).find(".frame_colors .color-control");
        if (this.options.F_frame || this.options.Z_frame) {
            let $hideEls = $colors.filter(".hide-on-Z,.hide-on-F"),
                $shownEls = $colors.filter(":not(.hide-on-Z,.hide-on-F)");

            if ($hideEls.is(".active")) {
                $hideEls.removeClass("active").find("input:radio").prop("checked", false);
                $shownEls.eq(0).addClass("active").find("input:radio").prop("checked", true);
            }
            $hideEls.hide();
            $shownEls.show();
        } else if (
            !this.options.no_grill &&
            (
                this.selection.series === "ITTL" ||
                this.selection.series === "ITTBL" ||
                this.selection.series === "ITTZ" ||
                this.selection.series === "ITTBZ"
            ) &&
            (
                this.options.grill === "SGL" ||
                this.options.grill === "SGZ"
            )
        ) {
            let $hideEls = $colors.filter(".ral");

            if ($hideEls.is(".active")) {
                $hideEls.removeClass("active").find("input:radio").prop("checked", false);
                $colors.eq(0).addClass("active").find("input:radio").prop("checked", true);
            }
            $hideEls.hide();
        } else {
            $colors.show();
        }

        return this;
    }

    normalizeNoGrillOption() {
        let variant = this.selection.variant;

        if ($("#" + variant + "_no-grill").is(":checked"))
            $("#" + variant + "_grill").find(".grills, .grill_colors").hide();
        else
            $("#" + variant + "_grill").find(".grills, .grill_colors").show();

        return this;
    }

    normalizeGrills() {
        let selection = this.selection,
            visota = this.dimensions.visota,
            shirina = this.dimensions.shirina,
            option_g = $("#" + selection.series + "_option_g").is(":checked");

        switch (selection.variant) {
            case "ITTN":
            case "ITTC":
                if (visota === 80 || shirina === 400) {
                    let $LGA = $("[name=" + selection.variant + "_grill][value=LGA]");
                    if ($LGA.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=SGA]").iCheck("check");
                    }
                    $LGA.prop("disabled", true);
                } else
                    $("[name=" + selection.variant + "_grill][value=LGA]").prop("disabled", false);
                break;
            case "ITTBN":
            case "ITTBC":
                if (shirina === 400) {
                    let $LGA = $("[name=" + selection.variant + "_grill][value=LGA]");
                    if ($LGA.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=SGA]").iCheck("check");
                    }
                    $LGA.prop("disabled", true);
                } else
                    $("[name=" + selection.variant + "_grill][value=LGA]").prop("disabled", false);
                break;
            case "ITTZN":
            case "ITTZC":
                if ((visota === 75 || shirina === 400)) {
                    let $LGA = $("[name=" + selection.variant + "_grill][value=LGA]");
                    if ($LGA.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=SGZ]").iCheck("check");
                    }
                    $LGA.prop("disabled", true);
                } else if (option_g) {
                    $("[name=" + selection.variant + "_grill][value=LGA]").prop("disabled", false);
                }

                break;
            case "ITTBZN":
            case "ITTBZC":
                if (!option_g && (visota === 75 || shirina === 200 || shirina === 400)) {
                    let $LGA = $("[name=" + selection.variant + "_grill][value=LGA]");
                    if ($LGA.is(":checked")) {
                        $("[name=" + selection.variant + "_grill]").filter("[value=SGZ]").iCheck("check");
                    }
                    $LGA.prop("disabled", true);
                } else if (option_g) {
                    $("[name=" + selection.variant + "_grill][value=LGA]").prop("disabled", false);
                }
                break;
            default:
                $(".grills input:radio").prop("disabled", false);
        }

        return this;
    }

    normalizeGrillColors(grill_series) {
        let $colors = $(grill_series).closest(".tab-pane").find(".grill_colors .color-control");
        $colors.removeClass("active").find("input:radio").prop("checked", false);
        $colors.filter(":not(." + grill_series.value + ")").hide();
        $colors.filter("." + grill_series.value).show().eq(0).addClass("active").find("input:radio").prop("checked", true);

        return this;
    }

    normalizeDlinas() {
        let shirina = this.dimensions.shirina,
            $dlina1 = this.$dimensions.$dlina1,
            $dlina2 = this.$dimensions.$dlina2,
            $dlina3 = this.$dimensions.$dlina3;

        switch (this.selection.variant) {
            case "ITTC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 200) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 800)
                        $dlina1
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina2.val() < 800)
                        $dlina2
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina3.val() < 800)
                        $dlina3
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());

                } else if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });

                    if (+$dlina1.val() < 900)
                        $dlina1
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 900)
                        $dlina2
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 900)
                        $dlina3
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });

                    if (+$dlina1.val() < 1000)
                        $dlina1
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1000)
                        $dlina2
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1000)
                        $dlina3
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });

                    if (+$dlina1.val() < 1100)
                        $dlina1
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1100)
                        $dlina2
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1100)
                        $dlina3
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1200)
                        $dlina1
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1200)
                        $dlina2
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1200)
                        $dlina3
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTLC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 160) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 800)
                        $dlina1
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 800)
                        $dlina2
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 800)
                        $dlina3
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 220 || shirina === 280) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 900)
                        $dlina1
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 900)
                        $dlina2
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 900)
                        $dlina3
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 340 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1000)
                        $dlina1
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1000)
                        $dlina2
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1000)
                        $dlina3
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBLC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 220 || shirina === 280) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1100)
                        $dlina1
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1100)
                        $dlina2
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1100)
                        $dlina3
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 340 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1200)
                        $dlina1
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1200)
                        $dlina2
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1200)
                        $dlina3
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTZC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 200) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 800)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 800)
                        $dlina1
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 800)
                        $dlina2
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 800)
                        $dlina3
                            .val(800)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 900)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 900)
                        $dlina1
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 900)
                        $dlina2
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 900)
                        $dlina3
                            .val(900)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1000)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1000)
                        $dlina1
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1000)
                        $dlina2
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1000)
                        $dlina3
                            .val(1000)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
            case "ITTBZC":
                $dlina1.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina2.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());
                $dlina3.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_Search_Options());

                if (shirina === 250 || shirina === 300) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1100)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1100)
                        $dlina1
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1100)
                        $dlina2
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1100)
                        $dlina3
                            .val(1100)
                            .select2(VendorPlugins.select2_Search_Options());
                } else if (shirina === 350 || shirina === 400) {
                    $dlina1.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina2.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    $dlina3.find("> option").each((index, item) => {
                        if (item.value < 1200)
                            item.disabled = "disabled";
                    });
                    if (+$dlina1.val() < 1200)
                        $dlina1
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina2.val() < 1200)
                        $dlina2
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                    if (+$dlina3.val() < 1200)
                        $dlina3
                            .val(1200)
                            .select2(VendorPlugins.select2_Search_Options());
                }
                break;
        }

        return this;
    }

    normalizeShirinas() {
        if (this.selection.variant === "ITTR") {
            this.$dimensions.$shirina.find("> option[value=300]").prop("disabled", true);
        }

        return this;
    }

    normalizeVisotas() {
        // if (this.selection.variant === "ITTR") {
        //     this.$dimensions.$visota.find("> option[value=140], > option[value=190]").prop("disabled", true);
        // }

        return this;
    }

    normalizePowerComponent() {
        let $input_t = $("#input_t"),
            input_t_val = +$input_t.val(),
            $output_t = $("#output_t"),
            output_t_val = +$output_t.val(),
            $room_t = $("#room_t"),
            room_t_val = +$room_t.val();

        if (input_t_val <= output_t_val) {
            input_t_val = output_t_val + 1;
            $input_t.val(input_t_val);
        }

        let delta_t_val = (input_t_val + output_t_val) / 2 - room_t_val;
        if (delta_t_val > 80) {
            delta_t_val = 80;
            input_t_val = delta_t_val + room_t_val + 1;
            output_t_val = delta_t_val + room_t_val - 1;
            $input_t.val(input_t_val);
            $output_t.val(output_t_val);
        }
        if (delta_t_val < 21) {
            delta_t_val = 21;
            input_t_val = delta_t_val + room_t_val + 1;
            output_t_val = delta_t_val + room_t_val - 1;
            $input_t.val(input_t_val);
            $output_t.val(output_t_val);
        }

        $("#column-temperature-badge").html($input_t.val() + "&deg;/" + $output_t.val() + "&deg;/" + $room_t.val() + "&deg;");

        return this;
    }

    normalizePower() {
        let nominal_t = 70; //deg. of celsius
        let delta_t = (Calculator.temperatures.input_t + Calculator.temperatures.output_t) / 2 - Calculator.temperatures.room_t;
        let opt = this.options;
        let Q1_from_server = KoeffsAndValues.getConvectorPower(opt);
        let Q2_from_server = 0;
        let Q3_from_server = 0;


        if (opt.isCorner && opt.dimensions.dlina2 && opt.dimensions.dlina2 > 0) {
            Q2_from_server = KoeffsAndValues.getConvectorPower(opt, 2);
        }

        if (opt.isCorner && opt.dimensions.dlina3 && opt.dimensions.dlina3 > 0) {
            Q3_from_server = KoeffsAndValues.getConvectorPower(opt, 3);
        }

        const koeff = KoeffsAndValues.getKoeffOfDelta_t(opt);

        const raschQ1 = Q1_from_server * Math.pow(delta_t / nominal_t, koeff),
            raschQ2 = Q2_from_server * Math.pow(delta_t / nominal_t, koeff),
            raschQ3 = Q3_from_server * Math.pow(delta_t / nominal_t, koeff)

        if (opt.vent) {
            const Kt = KoeffsAndValues.getKt(opt, Calculator.temperatures, koeff);
            const {Kv, Kv1, Kv2, Kv3} = KoeffsAndValues.getKv(opt);
            // const koeff_corr = Kt * Kv;
            // console.log("============")
            // console.log("============ Kt", Kt)
            // console.log("============ Kv", Kv)

            Calculator.Q =
                {
                    Q1: (raschQ1).toFixed(),
                    Q2: (raschQ2).toFixed(),
                    Q3: (raschQ3).toFixed(),
                    Vent_Q: (raschQ1 * Kt * Kv).toFixed(),
                    Vent_Q1: (raschQ1 * Kt * Kv1).toFixed(),
                    Vent_Q2: (raschQ2 * Kt * Kv2).toFixed(),
                    Vent_Q3: (raschQ3 * Kt * Kv3).toFixed(),
                };
        } else {
            Calculator.Q =
                {
                    Q1: (raschQ1).toFixed(),
                    Q2: (raschQ2).toFixed(),
                    Q3: (raschQ3).toFixed(),
                    Vent_Q1: '0',
                    Vent_Q2: '0',
                    Vent_Q3: '0'
                };
        }

        // Calculator.Q = ((Q1_from_server + Q2_from_server + Q3_from_server) * Math.pow(delta_t / nominal_t, koeff)).toFixed();
        return this;
    }

    normalizeHWOptions() {
        if (this.options.isFloor) {
            if ($("#ITF_options").is(":checked"))
                $(".ITF_options").show();
            else
                $(".ITF_options").hide();
        }

        return this;
    }

    normalizeNozhki() {
        if (this.options.HWoptions && this.options.W) {
            $("#ITF_visota_nozhki").prop("disabled", true);
        } else {
            $("#ITF_visota_nozhki").prop("disabled", false);
        }

        return this;
    }

    normalizeITFSizes() {
        const $visota = this.$dimensions.$visota;
        const $shirina = this.$dimensions.$shirina;
        const sizeLimits = KoeffsAndValues.getItfConvectorSizes();

        if (this.options.isFloor) {
            $visota.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_noSearch_Options());
            $shirina.find("> option").prop("disabled", false).parent().select2(VendorPlugins.select2_noSearch_Options());
            let visotas, shirinas;
            if (!this.options.HWoptions) {
                visotas = sizeLimits.itf.visotas;
                shirinas = sizeLimits.itf.shirinas;
            } else if (this.options.H) {
                visotas = sizeLimits.ith.visotas;
                shirinas = sizeLimits.ith.shirinas;
            } else if (this.options.W) {
                visotas = sizeLimits.itw.visotas;
                shirinas = sizeLimits.itw.shirinas;
            }
            $visota.find("> option").each((index, item) => {
                if (visotas.indexOf(+item.value) === -1)
                    item.disabled = "disabled";
            });
            $shirina.find("> option").each((index, item) => {
                if (shirinas.indexOf(+item.value) === -1)
                    item.disabled = "disabled";
            });
            $visota
                .val(visotas[0])
                .select2(VendorPlugins.select2_noSearch_Options());
            $shirina
                .val(shirinas[0])
                .select2(VendorPlugins.select2_noSearch_Options());
        }

        return this;
    }

    normalizeMountSchemes() {
        const opt = this.options;

        if (opt.isFloor) {
            const $schema_controls = $("#ITF_frame .schema-control");

            if (!opt.HWoptions && opt.dimensions.visota === 80 && opt.dimensions.shirina === 80) {
                $schema_controls.filter(":not(.SN, .S, .T)").addClass("disabled");
                $schema_controls.filter(".T").button("toggle");
            } else {
                $schema_controls.removeClass("disabled");
                $schema_controls.filter(".T").button("toggle");
            }
        }

        return this;
    }

    normalizeItfCommentLabel() {
        const opt = this.options;

        if (opt.isFloor) {
            if (["T", "TP", "TPN"].includes(opt.mount_scheme)) {
                $(".comments").html("Термоголовка <em>приобретаются</em> отдельно.<br>Осевой клапан <em>включён</em> в стоимость прибора");
            } else {
                $(".comments").html("Термоголовка <em>приобретаются</em> отдельно");
            }
        }

        return this;
    }

    normalizeAutomationSelects(event) {
        $("#blower-power").val($(event.target).find("> :selected").data("power"));
        return this;
    }

    onAddAutomationItemToTable(event) {
        let auto = this.automation,
            variant = $(event.target).closest(".automation_block").prop("id");
        if (variant === "to")
            variant = $("#to .variants > .active").prop("id");
        let add_count = parseFloat($("#" + variant + "_add_count").val().replace(',', '.')),
            priceFromServer = KoeffsAndValues.getAutomationPrice(auto, variant);
        let description = KoeffsAndValues.getAutomationDescription(auto, variant);
        let weight = KoeffsAndValues.getAutomationWeight(auto, variant);
        let volume = KoeffsAndValues.getAutomationVolume(auto, variant);
        let isBlockedDiscount = auto[variant]["bd"];
        let $next_tr = $("<tr>")
            // .append($('<th scope="row">1</th>'))
            .append($('<td class="font-weight-bold text-left"/>').text(KoeffsAndValues.getAutomationArtikul(auto, variant)))
            .append($('<td/>').text(((variant === "blowers") ? (auto[variant].power + " Вт") : "")))
            .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
            .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
            .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
            .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>'), isBlockedDiscount))
            .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
            .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
            .data("description", description).data("weight", weight).data("volume", volume);
        $("table.calculation tbody").append($next_tr);


        this.refreshSubTotal();

        let $table_container = $(".table-responsive")
        $table_container.scrollTop($table_container.prop("scrollHeight"));

        return this;
    }

    onAddItemToTable() {
        let opt = this.options,
            add_count = parseFloat($("#add_count").val().replace(',', '.'));

        console.debug(opt);

        if (!opt.dimensions.visota || isNaN(opt.dimensions.visota)) {
            alert("Неправильно введена высота!");
            return this;
        }
        if (!opt.dimensions.shirina || isNaN(opt.dimensions.shirina)) {
            alert("Неправильно введена ширина!");
            return this;
        }

        if (
            (!opt.dimensions.dlina || isNaN(opt.dimensions.dlina)) &&
            (
                !opt.dimensions.dlina1 || isNaN(opt.dimensions.dlina1) ||
                !opt.dimensions.dlina2 || isNaN(opt.dimensions.dlina2)
            )
        ) {
            alert("Неправильно введена Длина!");
            return this;
        }

        let priceFromServer = KoeffsAndValues.getConvectorPrice(opt);
        let articul = KoeffsAndValues.getArtikul(opt);
        let description = KoeffsAndValues.getConvectorDescription(opt);
        let weight = KoeffsAndValues.getConvectorWeight(opt);
        let volume = KoeffsAndValues.getConvectorVolume(opt);
        // let balance = KoeffsAndValues.getStoreBalance(opt)
        let balance = null

        let $next_tr = $("<tr>")
            // .append($('<th scope="row">1</th>'))
            .append($('<td class="font-weight-bold text-left"/>').text(articul))
            .append($('<td/>').text(((opt.vent) ? opt.Q.Vent_Q1 : opt.Q.Q1) + " Вт"))
            .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count), balance))
            .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
            .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
            .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
            .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
            .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
            .data("description", description).data("weight", weight).data("volume", volume);
        $("table.calculation tbody").append($next_tr);
        if (!opt.no_grill && !opt.isFloor) {
            priceFromServer = KoeffsAndValues.getGrillPrice(opt);
            articul = KoeffsAndValues.getGrillArtikul(opt);
            description = KoeffsAndValues.getGrillDescription(opt);
            weight = KoeffsAndValues.getGrillWeight(opt);
            volume = KoeffsAndValues.getGrillVolume(opt);
            $next_tr = $("<tr>")
                // .append($('<th scope="row">1</th>'))
                .append($('<td class="font-weight-bold text-left"/>').text(articul))
                .append($('<td> - </td>'))
                .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                .data("description", description).data("weight", weight).data("volume", volume)
                .insertAfter($next_tr);
        }

        if (opt.isCorner) {
            priceFromServer = KoeffsAndValues.getConvectorPrice(opt, 2);
            articul = KoeffsAndValues.getArtikul(opt, 2);
            description = KoeffsAndValues.getConvectorDescription(opt, 2);
            weight = KoeffsAndValues.getConvectorWeight(opt, 2);
            volume = KoeffsAndValues.getConvectorVolume(opt, 2);
            $next_tr = $("<tr>")
                // .append($('<th scope="row">1</th>'))
                .append($('<td class="font-weight-bold text-left"/>').text(articul))
                .append($('<td/>').text(((opt.vent) ? opt.Q.Vent_Q2 : opt.Q.Q2) + " Вт"))
                .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                .data("description", description).data("weight", weight).data("volume", volume)
                .insertAfter($next_tr);

            if (!opt.no_grill) {
                priceFromServer = KoeffsAndValues.getGrillPrice(opt, 2);
                articul = KoeffsAndValues.getGrillArtikul(opt, 2);
                description = KoeffsAndValues.getGrillDescription(opt, 2);
                weight = KoeffsAndValues.getGrillWeight(opt, 2);
                volume = KoeffsAndValues.getGrillVolume(opt, 2);
                $next_tr = $("<tr>")
                    // .append($('<th scope="row">1</th>'))
                    .append($('<td class="font-weight-bold text-left"/>').text(articul))
                    .append($('<td> - </td>'))
                    .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                    .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                    .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                    .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                    .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                    .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                    .data("description", description).data("weight", weight).data("volume", volume)
                    .insertAfter($next_tr);
            }

            if (opt.dimensions.dlina3) {
                priceFromServer = KoeffsAndValues.getConvectorPrice(opt, 3);
                articul = KoeffsAndValues.getArtikul(opt, 3);
                description = KoeffsAndValues.getConvectorDescription(opt, 3);
                weight = KoeffsAndValues.getConvectorWeight(opt, 3);
                volume = KoeffsAndValues.getConvectorVolume(opt, 3);
                $next_tr = $("<tr>")
                    // .append($('<th scope="row">1</th>'))
                    .append($('<td class="font-weight-bold text-left"/>').text(articul))
                    .append($('<td/>').text(((opt.vent) ? opt.Q.Vent_Q3 : opt.Q.Q3) + " Вт"))
                    .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                    .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                    .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                    .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                    .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                    .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                    .data("description", description).data("weight", weight).data("volume", volume)
                    .insertAfter($next_tr);

                if (!opt.no_grill) {
                    priceFromServer = KoeffsAndValues.getGrillPrice(opt, 3);
                    articul = KoeffsAndValues.getGrillArtikul(opt, 3);
                    description = KoeffsAndValues.getGrillDescription(opt, 3);
                    weight = KoeffsAndValues.getGrillWeight(opt, 3);
                    volume = KoeffsAndValues.getGrillVolume(opt, 3);
                    $next_tr = $("<tr>")
                        // .append($('<th scope="row">1</th>'))
                        .append($('<td class="font-weight-bold text-left"/>').text(articul))
                        .append($('<td> - </td>'))
                        .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                        .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                        .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                        .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                        .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                        .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                        .data("description", description).data("weight", weight).data("volume", volume)
                        .insertAfter($next_tr)
                }
            }
        }

        if (
            opt.hasBlower &&
            (
                (opt.vent24 && !opt.vent24_option.endsWith('_vent24_basic')) ||
                (!opt.vent24 && !opt.no_module)
            )
        ) {
            if (opt.vent24) {
                priceFromServer = (opt.vent24_option.endsWith('_vent24_module')) ? KoeffsAndValues.getModule24VPrice(opt) : KoeffsAndValues.getBPPrice(opt);
                articul = (opt.vent24_option.endsWith('_vent24_module')) ? KoeffsAndValues.getModule24VArtikul(opt) : KoeffsAndValues.getBPArtikul(opt);
                description = (opt.vent24_option.endsWith('_vent24_module')) ? KoeffsAndValues.getModule24VDescription(opt) : KoeffsAndValues.getBPDescription(opt);
            } else {
                priceFromServer = KoeffsAndValues.getModulePrice(opt);
                articul = KoeffsAndValues.getModuleArtikul(opt);
                description = KoeffsAndValues.getModuleDescription(opt);
            }

            $("<tr>")
                // .append($('<th scope="row">1</th>'))
                .append($('<td class="font-weight-bold text-left"/>').text(articul))
                .append($('<td> - </td>'))
                .append(CustomControls.makeTableQtyControl($('<td/>').text(add_count)))
                .append($('<td class="numbers"/>').text(Helpers.numberWithCommas(priceFromServer)))
                .append($('<td class="numbers font-weight-bold"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append(CustomControls.makeTableInputSpinner($('<td class="numbers discount"/>')))
                .append($('<td class="number font-weight-bold text-right"/>').text(Helpers.numberWithCommas(add_count * priceFromServer)))
                .append($('<td><a href="#" class="del-item"><img src="/assets/img/delete_normal.svg" alt="del"></a></td>'))
                .data("description", description).data("weight", 0).data("volume", 0)
                .insertAfter($next_tr);
        }

        this.refreshSubTotal();

        let $table_container = $(".table-responsive")
        $table_container.scrollTop($table_container.prop("scrollHeight"));

        return this;
    }

    refreshSubTotal() {
        console.debug('Refresh subtotal of table');

        let subtotal = 0.0, total = 0.0, total_weight = 0.0, total_volume = 0.0;

        $('table.calculation tbody tr')
            .each((index, item) => {
                subtotal += parseFloat(Helpers.cleanSpaces($(item).find("td").eq(4).text().trim()));
                total += parseFloat(Helpers.cleanSpaces($(item).find("td").eq(6).text().trim()));
                let weight = parseFloat($(item).data("weight")),
                    volume = parseFloat($(item).data("volume")),
                    item_count = +$(item).find("td").eq(2).find(".number").text();
                total_weight += (isNaN(weight) ? 0 : weight) * item_count;
                total_volume += (isNaN(volume) ? 0 : volume) * item_count;
            });

        $("#subtotal").text(Helpers.numberWithCommas(subtotal));
        $("#total_discount").text(Helpers.numberWithCommas(total - subtotal));
        $("#total").text(Helpers.numberWithCommas(total));
        $("#total_weight").val(total_weight.toFixed(2));
        $("#total_volume").val(total_volume.toFixed(4));
        return this;
    }

    get $dimensions() {
        let series = this.selection.series,
            variant = this.selection.variant,
            result = {
                $visota: $("#" + variant + "_visota"),
                $shirina: $("#" + variant + "_shirina")
            };
        if (variant === "ITTN" || variant === "ITTBN" || variant === "ITTLN" || variant === "ITTBLN" || variant === "ITTZN" || variant === "ITTBZN") {
            result.$dlina = $("#" + variant + "_dlina");
        } else if (variant === "ITTC" || variant === "ITTBC" || variant === "ITTLC" || variant === "ITTBLC" || variant === "ITTZC" || variant === "ITTBZC") {
            result.$dlina1 = $("#" + variant + "_dlina1");
            result.$dlina2 = $("#" + variant + "_dlina2");
            result.$dlina3 = $("#" + variant + "_dlina3");
            result.$ugol1 = $("#" + variant + "_ugol1");
            result.$ugol2 = $("#" + variant + "_ugol2");
        } else if (variant === "ITTR") {
            result.$dlina1 = $("#" + variant + "_dlina1");
            result.$dlina2 = $("#" + variant + "_dlina2");
        } else if (series === "ITF") {
            result.$visota = $("#" + series + "_visota");
            result.$shirina = $("#" + series + "_shirina");
            result.$dlina = $("#" + series + "_dlina");
        }

        return result;
    }

    get dimensions() {
        let $tmp = this.$dimensions,
            series = this.selection.series,
            variant = this.selection.variant,
            result = {
                visota: +$tmp.$visota.val(),
                shirina: +$tmp.$shirina.val()
            };

        if (variant === "ITTN" || variant === "ITTBN" || variant === "ITTLN" || variant === "ITTBLN" || variant === "ITTZN" || variant === "ITTBZN" || series === "ITF") {
            result.dlina = +$tmp.$dlina.val()
        } else if (variant === "ITTC" || variant === "ITTBC" || variant === "ITTLC" || variant === "ITTBLC" || variant === "ITTZC" || variant === "ITTBZC") {
            result.dlina1 = +$tmp.$dlina1.val();
            result.dlina2 = +$tmp.$dlina2.val();
            if (!$tmp.$dlina3.is(":disabled"))
                result.dlina3 = +$tmp.$dlina3.val();
            result.ugol1 = +$tmp.$ugol1.val();
            result.ugol2 = +$tmp.$ugol2.val();
        } else if (variant === "ITTR") {
            result.dlina1 = +$tmp.$dlina1.val();
            result.dlina2 = +$tmp.$dlina2.val();
        }

        return result;
    }

    get selection() {
        this.selected = {
            series: $('.convectors > .active').prop("id"),
            variant: $('.convectors > .active .variants > .active').prop("id"),
            previous: this.selected
        };

        return this.selected;
    }

    static get $temperatures() {
        return {
            $input_t: $("#input_t"),
            $output_t: $("#output_t"),
            $room_t: $("#room_t")
        }
    }

    static get temperatures() {
        let $tmp = Calculator.$temperatures;
        return {
            input_t: +$tmp.$input_t.val(),
            output_t: +$tmp.$output_t.val(),
            room_t: +$tmp.$room_t.val()
        }
    }

    static get Q() {
        let $Q = $("#IT_Q");
        // return +$Q.val();
        return {
            Q1: $Q.data("Q1"),
            Q2: $Q.data("Q2"),
            Q3: $Q.data("Q3"),
            Vent_Q1: $Q.data("Vent_Q1"),
            Vent_Q2: $Q.data("Vent_Q2"),
            Vent_Q3: $Q.data("Vent_Q3")
        }
    }

    static set Q(value) {
        $("#IT_Q")
            .data("Q1", value.Q1)
            .data("Q2", value.Q2)
            .data("Q3", value.Q3)
            .data("Vent_Q1", value.Vent_Q1)
            .data("Vent_Q2", value.Vent_Q2)
            .data("Vent_Q3", value.Vent_Q3)
            .val((+value.Q1) + (+value.Q2) + (+value.Q3));
    }

    get options() {
        let selection = this.selection,
            $vent = $("#" + selection.series + "_vent"),
            result = {
                convector: selection.series,
                variant: selection.variant,
                isCorner: ["ITTC", "ITTBC", "ITTLC", "ITTBLC", "ITTZC", "ITTBZC"].includes(selection.variant),
                isRadial: (selection.variant === "ITTR"),
                isFloor: selection.series === "ITF",
                hasBlower: ['ITTB', 'ITTBL', 'ITTBZ'].includes(selection.series),
                dimensions: this.dimensions,
                temperatures: Calculator.temperatures,
                Q: Calculator.Q,
                no_grill: $("#" + selection.variant + "_no-grill").is(":checked"),
                vent: $vent.is(":checked"),
                vent_option: ($vent.is(":checked")) ? {
                    prit_t: $("#" + selection.series + "_vent_option_t_vkhod").val(),
                    prit_raskh: $("#" + selection.series + "_vent_option_raskh_pritoch_vozd").val()
                } : {},
                G: $("#" + selection.series + "_option_g").is(":checked"),
                spec: $("#" + selection.series + "_spec").is(":checked"),
                drenazh: $("#" + selection.series + "_drenazh").is(":checked"),
                nerzh: $("#" + selection.series + "_nerzh").is(":checked"),
                F_frame: $("#" + selection.variant + "_f-frame").is(":checked"),
                Z_frame: $("#" + selection.variant + "_z-frame").is(":checked"),
                no_module: $("#" + selection.series + "_no-module").is(":checked"),
                vent24: $("#" + selection.series + "_vent24").is(":checked"),
                vent24_option: $("[name=" + selection.series + "_vent24_opts]:radio:checked").val()
            };

        if (result.isFloor) {
            result.frame_color = $("[name=" + selection.series + "_color]:checked").val();
            result.frame_ral_color = $("#" + selection.series + "_grill label.ral").data("ral");
        } else {
            result.frame_color = $("[name=" + selection.variant + "_color]:checked").val();
            result.frame_ral_color = $("#" + selection.variant + "_frame label.ral").data("ral");
        }

        if (!result.no_grill) {
            result.grill = $("[name=" + result.variant + "_grill]:checked").val();
            result.grill_color = $("[name=" + result.variant + "_grill_color]:checked").val();
            result.grill_ral_color = $("#" + selection.variant + "_grill label.ral").data("ral");
        }
        if (result.isFloor) {
            result.variant = "ITF";
            result.mount_scheme = $("[name=mount_scheme]:radio:checked").val();
            result.HWoptions = $("#" + selection.series + "_options").is(":checked");
            result.W = $("#" + selection.series + "_option_W").is(":checked");
            if (result.HWoptions && result.W) result.variant = "ITW";
            result.H = $("#" + selection.series + "_option_H").is(":checked");
            if (result.HWoptions && result.H) result.variant = "ITH";
            result.visota_nozhki = +$("#" + selection.series + "_visota_nozhki").val();
        }

        return result;
    }

    get automation() {
        let $curr_blower = $("#BLOWERS_list > :selected"),
            $curr_spare = $("#SPARES_list > :selected"),
            $curr_servo = $("#SERVOS_list > :selected");
        return {
            cassetes: {
                id: 0,
                name: "Cassete",
                mount_scheme: $("[name=cassette_scheme]:radio:checked").val(),
                dlina: +$("#CASSETE_dlina").val(),
                step: +$("#CASSETE_step").val(),
                color: $("[name=CASSETE_color]:checked").val(),
                color_ral: $("#cassetes label.ral").data("ral")
            },
            TO_ITT: {
                id: 0,
                name: "ТО",
                mount_scheme: $("#to_itt-scheme").text(),
                mf: $("#TO_ITT_option_MF").is(":checked"),
                dlina: +$("#TO_ITT_dlina").val(),
                step: +$("#TO_ITT_step").val(),
                color: $("[name=TO_ITT_color]:checked").val(),
                color_ral: $("#TO_ITT label.ral").data("ral")
            },
            TO_ITF: {
                id: 0,
                name: "ТОН",
                mount_scheme: $("#to_itf-scheme").text(),
                prisoed: $("#to_itf-scheme-mount").text(),
                dlina: +$("#TO_ITF_dlina").val(),
                color: $("[name=TO_ITF_color]:checked").val(),
                color_ral: $("#TO_ITF label.ral").data("ral")
            },
            servos: {
                id: $("#SERVOS_list").val(),
                name: $curr_servo.text(),
                bd: $curr_servo.data("bd")
            },
            blowers: {
                id: $("#BLOWERS_list").val(),
                name: $curr_blower.text(),
                power: $curr_blower.data("power")
            },
            controllers: {
                id: $("#CONTROLLERS_list").val(),
                name: $("#CONTROLLERS_list > :selected").text()
            },
            spares: {
                id: $("#SPARES_list").val(),
                name: $curr_spare.text(),
                units: $curr_spare.data("units")
            }
        };
    }
}

export default Calculator;